const login = require("../assets/background/login.png");
const map = require("../assets/background/map.png");
const avatar = require("../assets/background/avatar.png");

// users avatars
const users = {
  user_1: require("../assets/users/user_1.png"),
  user_2: require("../assets/users/user_2.png"),
  user_3: require("../assets/users/user_3.png"),
  user_4: require("../assets/users/user_4.png"),
  user_5: require("../assets/users/user_5.png"),
  user_6: require("../assets/users/user_6.png"),
  user_7: require("../assets/users/user_7.png"),
  user_8: require("../assets/users/user_8.png"),
};

// stories
const stories = {
  story_1: require("../assets/background/story_1.png"),
  story_2: require("../assets/background/story_2.png"),
  story_3: require("../assets/background/story_3.png"),
  story_4: require("../assets/background/story_4.png"),
  story_5: require("../assets/background/story_5.png"),
  story_6: require("../assets/background/story_6.png"),
};

export default {
  login,
  map,
  avatar,
  users,
  stories,
};
